<div [ngClass]="['banner', bannerType]" role="alert" aria-live="polite">
  <div class="me-3">
    @switch (bannerType) {
      @case (BannerType.info) {
        <ds-icon [icon]="Icons.CircleInfo" [iconStyle]="IconStyles.Light" [style.color]="EapColors.BlueInfo"> </ds-icon>
      }
      @case (BannerType.error) {
        <ds-icon [icon]="Icons.TriangleExclamation" [iconStyle]="IconStyles.Light" [style.color]="EapColors.RedSeverityCritical">
        </ds-icon>
      }
      @case (BannerType.check) {
        <ds-icon [icon]="Icons.Check" [iconStyle]="IconStyles.Light" [style.color]="EapColors.GreenSeverityLow"> </ds-icon>
      }
    }
  </div>
  <div class="d-flex flex-column lh-lg">
    <ng-content></ng-content>
  </div>
  <div class="ms-auto">
    <button
      ds-button
      (click)="onClose.emit()"
      [attr.aria-label]="'label_close' | translate"
      [variant]="DsButtonVariants.microAction"
      [microActionIcon]="Icons.XMark"
    ></button>
  </div>
</div>
